import { memo } from 'react';
import { themeCssVar as theme } from '@tinderapp/ui-react';

import SvgIcon from './lib/SvgIcon';

type Props = React.ComponentProps<typeof SvgIcon> & {
  pathClassName?: string;
  fill?: string;
};

const ClockIcon = (props: Props) => {
  const {
    pathClassName,
    fill = theme.gradientFill.backgroundLike, // @TODO: overloaded token
    ...restProps
  } = props;

  return (
    <SvgIcon {...restProps}>
      <path
        className={pathClassName}
        fill={fill}
        d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z"
      />
    </SvgIcon>
  );
};

ClockIcon.normalized = true;

export default memo(ClockIcon);
